import { apiAuth } from "./conection";

export const createOrder = async (orderData) => {
  try {
    const response = await apiAuth.post("/orders", orderData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrderByUserId = async (userId) => {
  try {
    const response = await apiAuth.get(`/orders/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const orderServices = {
  createOrderWhatsApp: async (orderData) => {
    try {
      const response = await apiAuth.post("/orders/whatsapp", orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao criar pedido" };
    }
  },
};
